const products = [
  {
    id: "vpn",
    badge: "Privacy & Security",
    badgeIcon: "ri-shield-keyhole-line",
    name: "BAZA VPN",
    tagline: "Military-Grade Privacy for iOS",
    description:
      "A blazing-fast, zero-log VPN engineered for iOS. Protect your identity, bypass restrictions, and browse with complete confidence — anywhere in the world.",
    highlights: ["256-bit AES Encryption", "Zero-Log Policy", "Global Server Network", "Kill Switch Protection"],
    image:
      "https://public.readdy.ai/ai/img_res/f46491e7adf1e9e516dba037d41687e5.jpg",
    dark: true,
  },
  {
    id: "cleaner",
    badge: "Performance",
    badgeIcon: "ri-speed-line",
    name: "BAZA Cleaner",
    tagline: "Optimize Your iPhone, Instantly",
    description:
      "Reclaim storage, remove junk files, and keep your iPhone running at peak performance. Smart scanning technology identifies what slows you down.",
    highlights: ["Smart Junk Detection", "Photo Deduplication", "Memory Optimizer", "Battery Health Monitor"],
    image:
      "https://readdy.ai/api/search-image?query=clean%20white%20iOS%20cleaner%20app%20interface%20on%20iPhone%20mockup%2C%20minimalist%20design%20with%20progress%20circles%20and%20storage%20stats%2C%20light%20background%2C%20modern%20UI%20with%20green%20accents%2C%20performance%20dashboard%2C%20premium%20mobile%20app%20screenshot&width=600&height=700&seq=cleaner001&orientation=portrait",
    dark: false,
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-gray-400 uppercase mb-4">/ Our Products</p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              Built for iOS.<br />Designed for You.
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-sm leading-relaxed">
            Two flagship applications crafted to protect your privacy and maximize your device&apos;s potential.
          </p>
        </div>

        {/* Product Cards */}
        <div className="flex flex-col gap-8" data-product-shop>
          {products.map((p) => (
            <div
              key={p.id}
              className={`rounded-3xl overflow-hidden flex flex-col lg:flex-row ${
                p.dark ? "bg-gray-900 text-white" : "bg-[#F7F6F2] text-gray-900"
              }`}
            >
              {/* Content */}
              <div className="flex-1 p-8 md:p-12 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-6">
                    <div
                      className={`w-7 h-7 flex items-center justify-center rounded-lg ${
                        p.dark ? "bg-white/10" : "bg-gray-900"
                      }`}
                    >
                      <i className={`${p.badgeIcon} text-sm ${p.dark ? "text-white" : "text-white"}`} />
                    </div>
                    <span
                      className={`text-xs font-semibold tracking-widest uppercase ${
                        p.dark ? "text-white/50" : "text-gray-500"
                      }`}
                    >
                      {p.badge}
                    </span>
                  </div>
                  <h3 className="text-3xl md:text-4xl font-extrabold mb-3">{p.name}</h3>
                  <p className={`text-lg font-medium mb-5 ${p.dark ? "text-emerald-400" : "text-teal-600"}`}>
                    {p.tagline}
                  </p>
                  <p className={`text-sm md:text-base leading-relaxed max-w-md ${p.dark ? "text-white/70" : "text-gray-600"}`}>
                    {p.description}
                  </p>
                </div>

                {/* Highlights */}
                <div className="mt-8 grid grid-cols-2 gap-3">
                  {p.highlights.map((h) => (
                    <div key={h} className="flex items-center gap-2">
                      <div
                        className={`w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 ${
                          p.dark ? "bg-emerald-500/20" : "bg-teal-100"
                        }`}
                      >
                        <i className={`ri-check-line text-xs ${p.dark ? "text-emerald-400" : "text-teal-600"}`} />
                      </div>
                      <span className={`text-sm ${p.dark ? "text-white/70" : "text-gray-600"}`}>{h}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Image */}
              <div className="lg:w-80 xl:w-96 h-64 lg:h-auto flex-shrink-0">
                <img
                  src={p.image}
                  alt={`${p.name} app screenshot`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
